export const LAY_THONG_TIN_HE_THONG_RAP =
  "@quanLyRapReducer/LAY_THONG_TIN_HE_THONG_RAP";
export const LAY_THONG_TIN_CUM_RAP_THEO_HE_THONG =
  "@quanLyRapReducer/LAY_THONG_TIN_CUM_RAP_THEO_HE_THONG";
export const LAY_THONG_TIN_LICH_CHIEU_HE_THONG_RAP =
  "@quanLyRapReducer/LAY_THONG_TIN_LICH_CHIEU_HE_THONG_RAP";
export const LAY_THONG_TIN_LICH_CHIEU_PHIM =
  "@quanLyRapReducer/LAY_THONG_TIN_LICH_CHIEU_PHIM";
